export default {
    type: 'widget',
    config: {},
    default: {},
    unique: [
        {
            key: 'user_rating',
            type: 'checklist',
            default: 'disabled',
            name: 'User Rating',
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show user rating',
                    description: 'Show user rating'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide user rating',
                    description: 'Don\'t show user rating'
                }
            ]
        },
        {
            key: 'bgg_rating',
            type: 'checklist',
            default: 'disabled',
            name: 'Community Rating',
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show community rating',
                    description: 'Show community rating'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide community rating',
                    description: 'Don\'t show community rating'
                }
            ]
        }
    ],
    lang: {
        name: 'Card Head',
        views: [],
        category: ['Game', 'Ratings'],
        description: 'Image of game with optional user and communityratings.'
    }
}